import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import * as i3 from '@spartacus/core';
import { isNotNullable, useFeatureStyles, I18nModule, UrlModule, FeaturesConfigModule, provideDefaultConfig } from '@spartacus/core';
import * as i2 from '@spartacus/storefront';
import { ICON_TYPE, IconModule, AtMessageModule } from '@spartacus/storefront';
import { filter, tap, map } from 'rxjs/operators';
import * as i1 from '@spartacus/cart/wish-list/root';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i5 from '@angular/router';
import { RouterModule } from '@angular/router';

/*
 * SPDX-FileCopyrightText: 2024 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const _c0 = () => ({
  cxRoute: "login"
});
function AddToWishListComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_1_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 5);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵlistener("click", function AddToWishListComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_1_ng_container_1_div_1_Template_button_click_1_listener() {
      const entry_r2 = i0.ɵɵrestoreView(_r1).ngIf;
      const ctx_r2 = i0.ɵɵnextContext(6);
      return i0.ɵɵresetView(ctx_r2.remove(entry_r2));
    });
    i0.ɵɵelement(4, "cx-icon", 6);
    i0.ɵɵelementStart(5, "span", 7);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", i0.ɵɵpipeBind1(2, 4, ctx_r2.loading$))("cxAtMessage", i0.ɵɵpipeBind1(3, 6, "addToWishList.removedFromWishList"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r2.iconTypes.HEART);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 8, "addToWishList.remove"));
  }
}
function AddToWishListComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_1_ng_container_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("click", function AddToWishListComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_1_ng_container_1_ng_template_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const product_r5 = i0.ɵɵnextContext(5).ngIf;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.add(product_r5));
    });
    i0.ɵɵelement(3, "cx-icon", 6);
    i0.ɵɵelementStart(4, "span", 7);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("disabled", i0.ɵɵpipeBind1(1, 4, ctx_r2.loading$))("cxAtMessage", i0.ɵɵpipeBind1(2, 6, "addToWishList.addedToWishList"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r2.iconTypes.EMPTY_HEART);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 8, "addToWishList.add"));
  }
}
function AddToWishListComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AddToWishListComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_1_ng_container_1_div_1_Template, 8, 10, "div", 3)(2, AddToWishListComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_1_ng_container_1_ng_template_2_Template, 7, 10, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const addItem_r6 = i0.ɵɵreference(3);
    const entries_r7 = i0.ɵɵnextContext(2).ngIf;
    const product_r5 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.getProductInWishList(product_r5, entries_r7))("ngIfElse", addItem_r6);
  }
}
function AddToWishListComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_1_ng_container_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 9);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵlistener("click", function AddToWishListComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_1_ng_container_2_div_1_Template_button_click_1_listener() {
      const entry_r9 = i0.ɵɵrestoreView(_r8).ngIf;
      const ctx_r2 = i0.ɵɵnextContext(6);
      return i0.ɵɵresetView(ctx_r2.remove(entry_r9));
    });
    i0.ɵɵelement(4, "cx-icon", 6);
    i0.ɵɵelementStart(5, "span", 7);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", i0.ɵɵpipeBind1(2, 4, ctx_r2.loading$))("cxAtMessage", i0.ɵɵpipeBind1(3, 6, "addToWishList.removedFromWishList"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r2.iconTypes.HEART);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 8, "addToWishList.remove"));
  }
}
function AddToWishListComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_1_ng_container_2_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("click", function AddToWishListComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_1_ng_container_2_ng_template_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const product_r5 = i0.ɵɵnextContext(5).ngIf;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.add(product_r5));
    });
    i0.ɵɵelement(3, "cx-icon", 6);
    i0.ɵɵelementStart(4, "span", 7);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("disabled", i0.ɵɵpipeBind1(1, 4, ctx_r2.loading$))("cxAtMessage", i0.ɵɵpipeBind1(2, 6, "addToWishList.addedToWishList"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r2.iconTypes.EMPTY_HEART);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 8, "addToWishList.add"));
  }
}
function AddToWishListComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AddToWishListComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_1_ng_container_2_div_1_Template, 8, 10, "div", 3)(2, AddToWishListComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_1_ng_container_2_ng_template_2_Template, 7, 10, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const addItem_r11 = i0.ɵɵreference(3);
    const entries_r7 = i0.ɵɵnextContext(2).ngIf;
    const product_r5 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.getProductInWishList(product_r5, entries_r7))("ngIfElse", addItem_r11);
  }
}
function AddToWishListComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AddToWishListComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_1_ng_container_1_Template, 4, 2, "ng-container", 4)(2, AddToWishListComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_1_ng_container_2_Template, 4, 2, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yLinkBtnsToTertiaryBtns");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yLinkBtnsToTertiaryBtns");
  }
}
function AddToWishListComponent_ng_container_0_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AddToWishListComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_1_Template, 3, 2, "ng-container", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.hasStock);
  }
}
function AddToWishListComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AddToWishListComponent_ng_container_0_ng_container_1_ng_container_1_Template, 2, 1, "ng-container", 2);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r2.wishListEntries$));
  }
}
function AddToWishListComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AddToWishListComponent_ng_container_0_ng_container_1_Template, 3, 3, "ng-container", 3);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const loginPrompt_r12 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx_r2.userLoggedIn$))("ngIfElse", loginPrompt_r12);
  }
}
function AddToWishListComponent_ng_template_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 11);
    i0.ɵɵpipe(2, "cxUrl");
    i0.ɵɵelement(3, "cx-icon", 6);
    i0.ɵɵelementStart(4, "span", 7);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpureFunction0(7, _c0)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r2.iconTypes.EMPTY_HEART);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 5, "addToWishList.anonymous"));
  }
}
function AddToWishListComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AddToWishListComponent_ng_template_2_ng_container_0_Template, 7, 8, "ng-container", 2);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.hasStock);
  }
}
let AddToWishListComponent = /*#__PURE__*/(() => {
  class AddToWishListComponent {
    constructor(wishListFacade, currentProductService, authService) {
      this.wishListFacade = wishListFacade;
      this.currentProductService = currentProductService;
      this.authService = authService;
      this.product$ = this.currentProductService.getProduct().pipe(filter(isNotNullable), tap(product => this.setStockInfo(product)));
      this.userLoggedIn$ = this.authService.isUserLoggedIn().pipe(tap(isLogin => {
        if (isLogin) {
          this.wishListEntries$ = this.getWishListEntries();
          this.loading$ = this.wishListFacade.getWishListLoading();
        }
      }));
      this.hasStock = false;
      this.iconTypes = ICON_TYPE;
      useFeatureStyles('a11yVisibleFocusOverflows');
    }
    add(product) {
      if (product.code) {
        this.wishListFacade.addEntry(product.code);
      }
    }
    remove(entry) {
      this.wishListFacade.removeEntry(entry);
    }
    getProductInWishList(product, entries) {
      const item = entries.find(entry => entry.product?.code === product.code);
      return item;
    }
    setStockInfo(product) {
      this.hasStock = Boolean(product.stock && product.stock.stockLevelStatus !== 'outOfStock');
    }
    getWishListEntries() {
      return this.wishListFacade.getWishList().pipe(filter(wishlist => Boolean(wishlist)), map(wishList => wishList.entries ?? []));
    }
    static {
      this.ɵfac = function AddToWishListComponent_Factory(t) {
        return new (t || AddToWishListComponent)(i0.ɵɵdirectiveInject(i1.WishListFacade), i0.ɵɵdirectiveInject(i2.CurrentProductService), i0.ɵɵdirectiveInject(i3.AuthService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AddToWishListComponent,
        selectors: [["cx-add-to-wishlist"]],
        decls: 4,
        vars: 3,
        consts: [["loginPrompt", ""], ["addItem", ""], [4, "ngIf"], [4, "ngIf", "ngIfElse"], [4, "cxFeature"], [1, "btn", "btn-tertiary", "button-remove", 3, "click", "disabled", "cxAtMessage"], [3, "type"], [1, "button-text"], [1, "btn", "btn-tertiary", "button-add", 3, "click", "disabled", "cxAtMessage"], [1, "btn", "btn-link", "button-remove", "cx-action-link", 3, "click", "disabled", "cxAtMessage"], [1, "btn", "btn-link", "button-add", "cx-action-link", 3, "click", "disabled", "cxAtMessage"], [1, "btn", "btn-link", "button-add-link", "cx-action-link", 3, "routerLink"]],
        template: function AddToWishListComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, AddToWishListComponent_ng_container_0_Template, 3, 4, "ng-container", 2);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵtemplate(2, AddToWishListComponent_ng_template_2_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.product$));
          }
        },
        dependencies: [i4.NgIf, i2.IconComponent, i5.RouterLink, i2.AtMessageDirective, i3.FeatureDirective, i4.AsyncPipe, i3.TranslatePipe, i3.UrlPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return AddToWishListComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2024 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let AddToWishListModule = /*#__PURE__*/(() => {
  class AddToWishListModule {
    static {
      this.ɵfac = function AddToWishListModule_Factory(t) {
        return new (t || AddToWishListModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AddToWishListModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            AddToWishListComponent: {
              component: AddToWishListComponent
            }
          }
        })],
        imports: [CommonModule, I18nModule, IconModule, RouterModule, UrlModule, AtMessageModule, FeaturesConfigModule]
      });
    }
  }
  return AddToWishListModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2024 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddToWishListComponent, AddToWishListModule };
